import { Wizard } from '@/components/wizard/Wizard';
import { useUser } from '@/contexts/useUser';
import { useWorkspace } from '@/contexts/useWorkspace';

import { AzureConnectRestoreFlow } from './azureConnectRestoreFlow';
export interface AzureRestoreAccountState {
  projectId: string;
  tenantId: string;
  restoreSubscriptionId: string;
  restoreResourceGroupName?: string;
  eonInternalResourceGroupName?: string;
  restoreConnectType: 'subscription' | 'resourceGroup';
  restoreConnectMethod: 'terraform' | 'bash';
  name?: string;
}

export function AzureConnectRestoreWizard({
  onCreated,
}: {
  onCreated: (accountId: string) => Promise<void>;
}) {
  const { rightPanel } = useWorkspace();
  const { currentProjectId } = useUser();

  const onFinish = async (state: AzureRestoreAccountState) => {
    await onCreated(state.restoreSubscriptionId || '');
    return true;
  };

  return (
    <Wizard<AzureRestoreAccountState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[AzureConnectRestoreFlow]}
      title='Connect restore subscription'
      initialState={{
        restoreSubscriptionId: '',
        projectId: currentProjectId,
        tenantId: '',
        restoreConnectType: 'subscription',
        restoreConnectMethod: 'terraform',
      }}
    />
  );
}
